import { render, staticRenderFns } from "./VideoEncourageActivity.vue?vue&type=template&id=0b60ace6&scoped=true"
import script from "./VideoEncourageActivity.vue?vue&type=script&lang=js"
export * from "./VideoEncourageActivity.vue?vue&type=script&lang=js"
import style0 from "./VideoEncourageActivity.vue?vue&type=style&index=0&id=0b60ace6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b60ace6",
  null
  
)

export default component.exports